import { Content, Item, List, Link as RadLink, Root, Trigger, Viewport } from '@radix-ui/react-navigation-menu';
import { useEffect, useState } from 'react';

import Link from 'molecules/Link';

import MegaMenu from 'layout/header/components/MegaMenu';
import useHeaderStore, { closeDesktopMenu, openDesktopMenu } from 'layout/header/store';
import { menuLinkStyle, viewportStyle } from 'layout/header/styles';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

interface NavigationProps {
  menuItems?: HeaderNavigation[];
}

const MenuLink: FC<{ item: HeaderNavigation }> = ({ item }) => (
  <RadLink asChild key={item.label}>
    <Link href={item?.link || '/'} className={menuLinkStyle} enablePreview={false}>
      {item?.label}
    </Link>
  </RadLink>
);

const MenuDropdown: FC<{ item: HeaderNavigation }> = ({ item }) => (
  <Trigger className={menuLinkStyle} onClick={e => e.preventDefault()}>
    {item?.label}
  </Trigger>
);

const Navigation: FC<NavigationProps> = ({ menuItems }) => {
  const [value, setValue] = useState<string>('');
  const open = useHeaderStore(state => state.desktopMenuOpen);

  useEffect(() => {
    !open && setValue('');
  }, [open]);

  useEffect(() => {
    value ? openDesktopMenu() : closeDesktopMenu();
  }, [value]);

  return (
    <Root defaultValue="" value={value} onValueChange={setValue}>
      <List className="hidden items-center xl:flex xl:gap-8">
        {hasArrayValues(menuItems) &&
          menuItems.map(item => (
            <Item key={item.label}>
              {item?.megaMenu?.menu ? <MenuDropdown item={item} /> : <MenuLink item={item} />}
              {item?.megaMenu?.menu && (
                <Content className="hidden lg:flex">
                  <MegaMenu {...item.megaMenu} />
                </Content>
              )}
            </Item>
          ))}
      </List>
      <Viewport className={viewportStyle} />
    </Root>
  );
};

export default Navigation;
